import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCategory } from "../../redux/action";
import { useParams, useNavigate } from "react-router-dom";
import "./CategoryPopup.scss";

const CategoryPopup = ({ open, onClose }) => {
  const { restaurant, id, table } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuList = useSelector((state) => state?.user.menu || []);
  const categories = menuList?.categories || [];
  if (!open) return null;

  console.log("menuList", menuList);
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <label className="popup-lable">Browse Menu</label>

        <div className="pop-btn-row">
          <div className="popup-scroll">
            <button className="close-btn round-close-btn" onClick={onClose}>
              {" "}
              ✕{" "}
            </button>

            {categories.map((val) => (
              <div
                className="popup-row"
                key={val.categoryId}
                onClick={() => {
                  dispatch(setSelectedCategory(val.categoryId)); // 👈 send selected categoryId
                  navigate(`/${restaurant}/${id}/${table}/menu`);
                  onClose(); // close popup after click
                }}
              >
                <span>{val.categoryName}</span>
                <span>{val.items.length}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPopup;
